import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { Accomplishment } from "../../models/Accomplishment";
import { ColorUtils } from "../../utils/ColorUtils";
import { useStyles } from "../Main/formStyles";
import AccomplishmentCreateModal from "./AccomplishmentCreateModal";

interface Props {
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
  currentAccomplishment: Accomplishment | undefined;
  setCurrentAccomplishment: (value: Accomplishment | undefined) => void;
  handleOnUpdate: (instance: Accomplishment) => void;
  links: string[];
  setLinks: (value: string[]) => void;
  isLoading: boolean;
}

export default function AccomplishmentEditFormModal({
  isEdit,
  setIsEdit,
  currentAccomplishment,
  setCurrentAccomplishment,
  handleOnUpdate,
  links,
  setLinks,
  isLoading,
}: Props) {
  const customStyles = useStyles();
  
  return (
    <GenericForm<Accomplishment>
      headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
      buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
      cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
      dialogStyles={customStyles.root}
      dialog={true}
      open={!!isEdit}
      instance={currentAccomplishment}
      onSave={(instance) => {
        handleOnUpdate(instance);
      }}
      onCancel={() => {
        setIsEdit(false);
        setLinks([]);
        setCurrentAccomplishment(undefined);
      }}
      title={"Edit Accomplishment"}
      renderContent={(register, errors, control) => (
        <AccomplishmentCreateModal
          register={register}
          errors={errors}
          control={control}
          isLoading={isLoading}
          setLinks={setLinks}
          links={links}
          instance={currentAccomplishment!}
        />
      )}
    />
  );
}
